import React from 'react';

import { PromptMessage } from "../common/index.js";
import check from "../assets/check.svg";
import medal from "../assets/medal.svg";
import { translationPrefix } from "../data/index.js";

import Translation from '../../../../services/translation.service.js';

const FormEntry = ({ onContinue, goToSiteHome }) => {
  return(
    <div className="form-entry-container">
      <div>
        <img src={check} alt="Check icon" />
      </div>
      <div className="title">{Translation.keys[translationPrefix + "survey_thankyou"]}</div>
      <div className="description">
        {Translation.keys[translationPrefix + "take_survey_description"]}
      </div>
      <PromptMessage />
      <button className="common-button go-to-survey-btn" onClick={() => onContinue("rating")}>
        <img src={medal} alt="Medal icon" />
        <div className="text">
          {Translation.keys[translationPrefix + "take_survey_button"]}
        </div>
      </button>
      <button className="common-button-text" onClick={goToSiteHome}>
        {Translation.keys[translationPrefix + "take_survey_skip_button"]}
      </button>
    </div>
  )
}

export default FormEntry;